"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LabelText = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _toggleTheme = require("./toggleTheme");
const LabelText = (0, _styled.default)("span")`
    // Ensure proper alignment, especially when labelPlacement="start"
    flex-grow: 1;
    // Add small margin to center-align first line of text with toggle.
    margin-top: ${_ref => {
  let {
    size,
    themeMode
  } = _ref;
  return _toggleTheme.toggleTheme.labelMarginTop[size](themeMode);
}};

    ${_ref2 => {
  let {
    placement,
    themeMode
  } = _ref2;
  switch (placement) {
    case "start":
      return `margin-right: ${_toggleTheme.toggleTheme.labelGap(themeMode)};`;
    case "end":
    default:
      return `margin-left: ${_toggleTheme.toggleTheme.labelGap(themeMode)};`;
  }
}}

    ${_ref3 => {
  let {
    isDisabled
  } = _ref3;
  if (isDisabled) {
    return "opacity: 0.4;";
  }
}}
`;
exports.LabelText = LabelText;
//# sourceMappingURL=LabelText.js.map